import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeadCell,
    TableRow,
    TextInput,
    Button,
    Spinner
  } from "flowbite-react";
  import {ArrowRight,ArrowLeft} from "lucide-react"
  import axios from "axios";
  import { useEffect, useState } from "react";
  import {useNavigate} from "react-router-dom";
const SimsPage = () => {
 const [sims, setSims] = useState([]);
 const [loading, setLoading] = useState(false);
 const [searchTerm, setSearchTerm] = useState("");
 const [currentPage, setCurrentPage] = useState(1);
 const [totalPages, setTotalPages] = useState(0);
 const [totalSims, setTotalSims] = useState(0);
 const [limit] = useState(10);
 const navigate = useNavigate()
 const fetchSims = async (page = 1, search = "") => {
   try {
       setLoading(true);
       const response = await axios.get(
           `${process.env.REACT_APP_BACKEND_URL}userRelatedSims/?page=${page}&limit=${limit}&search=${search}`,
           { withCredentials: true }
       );
       setSims(response.data.data);
       setTotalPages(response.data.totalPages);
       setCurrentPage(response.data.currentPage);
       setTotalSims(response.data.total);
       setLoading(false);
   } catch (error) {
       console.log(error);
       setLoading(false);
   }
 };
 
 const handleSearch = (e) => {
   setSearchTerm(e.target.value);
   setCurrentPage(1); // Reset to first page when searching
 };
 
 useEffect(() => {
   const delayDebounceFn = setTimeout(() => {
       fetchSims(currentPage, searchTerm);
   }, 500);
 
   return () => clearTimeout(delayDebounceFn);
 }, [searchTerm, currentPage,navigate]);
 
 console.log(sims)
   return (
     <section className=" dark:bg-gray-900 w-full flex flex-col gap-3 mt-4">
             <div className="grid w-full grid-cols-1">
         <div className="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:flex dark:border-gray-700 sm:p-6 dark:bg-gray-800 mb-2">
           <div className="w-full sm:w-1/2 p-2">
             <span className="text-2xl font-bold leading-none text-gray-900 sm:text-3xl dark:text-white">
               Mes Sims
             </span>
           </div>
           <div className="w-full sm:w-1/2 p-2">
                                 <TextInput
                                     type="text"
                                     placeholder="Rechercher..."
                                     value={searchTerm}
                                     onChange={handleSearch}
                                 />
                             </div>
         </div>
             </div>
             <div className="overflow-x-auto rounded-md">
             <Table striped>
             <TableHead>
               
                 <TableHeadCell>ICCID</TableHeadCell>
                 <TableHeadCell>SN</TableHeadCell>
                 <TableHeadCell>Batch</TableHeadCell>
                 <TableHeadCell>statut</TableHeadCell>
                
                 
             </TableHead>
             
             <TableBody className="divide-y">
                 {sims?.length ? sims?.map((sim, index) => (
                 <TableRow key={index} className="bg-white dark:border-gray-700 dark:bg-gray-800 cursor-pointer hover:bg-slate-300"
                  
                 >
                     <TableCell >{sim?.ICCID}</TableCell>
                     <TableCell>{sim?.SN}</TableCell>
                     <TableCell>{sim?.batch_id?.batch_name}</TableCell>
                     <TableCell>{sim?.status}</TableCell>
                    
                 </TableRow>
                 )) : 
                 <TableRow className="bg-white dark:border-gray-700 dark:bg-gray-800 cursor-pointer hover:bg-slate-300">
                     <TableCell> {loading ? <Spinner/> : "Aucune carte sim trouvée ."}</TableCell>
                     
                 </TableRow>
                 }
             </TableBody> 
             </Table>
             </div>
             <section className="md:px-4 bg-white dark:bg-gray-800 text-gray-900 dark:text-white rounded-md w-full p-2 flex flex-row justify-between">
             <div className="flex justify-center items-center gap-2">
                         <Button
                            disabled={currentPage === 1 || totalPages === 0}
                             onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                             color = {"dark"}
                             size="xs"
                         >
                             <ArrowLeft size={16} /> 
                         </Button>
                         <span className="self-center">
                             Page {currentPage} / {totalPages}
                         </span>
                         <Button
                             disabled={currentPage === totalPages || totalPages === 0}
                             onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                             color = {"dark"}
                             size="xs"
                         >
                             <ArrowRight size={16} />
                         </Button>
             </div>
             <div>
               <span>Total : {totalSims}</span>
             </div>
             </section>
            
     </section> 
   );
 };

export default SimsPage